import { createRoute } from '@tanstack/react-router';
import ParticipantsPage from '@/features/dashboard/participants/pages/ParticipantsPage.tsx';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';
import { listSearchSchema } from '@/components/table/routes/listSearchParams.ts';

export const participantsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/participants',
  component: ParticipantsPage,
  validateSearch: listSearchSchema,
});
